import styled from 'styled-components';
import OfferActionsList from './OfferActionsList';
import { colorSchema } from 'utils/style';

export default styled(OfferActionsList)`
  display: flex;
  height: 100%;

  .offer-actions {
    align-items: center;
    display: flex;
    flex-direction: row;
    margin: 0;
    width: auto;

    &__primary {
      margin: 0 1.6rem 0 0;
      width: auto;
      min-width: 10rem;
    }

    &__secondary {
      width: 4rem;
    }

    &__error {
      padding: 0 2rem;
      svg {
        color: ${colorSchema('error700')};
      }
    }

    &__loading {
      padding: 0 2rem;
    }

    &__requested-container {
      background-color: ${props =>
        props.expanded ? colorSchema('grey700') : 'none'};
      color: ${colorSchema('white')};
      display: flex;
      padding: 0;
      width: 100%;
    }

    &__requested-icon {
      align-items: center;
      display: flex;
      margin-right: 1rem;
      svg {
        fill: ${colorSchema('grey700')};
      }
    }

    &__requested-title {
      align-items: center;
      color: ${colorSchema('grey700')};
      display: flex;
      font-weight: bold;
    }
  }
`;
